import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { sportFromSlug } from "@/lib/sportRoutes";

/** Resolves a travelsports.info/<sport>/<slug> custom address to the team /
 *  trainer listing it points at, then redirects. */
export default function SlugRedirect() {
    const { sport, slug } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(false);

    useEffect(() => {
        // If the first segment isn't a real sport, this isn't a listing URL — go home.
        if (!sportFromSlug(sport)) { navigate("/", { replace: true }); return; }
        let active = true;
        api.get(`/public/custom-url/${encodeURIComponent(sport)}/${encodeURIComponent(slug)}`)
            .then(({ data }) => {
                if (!active) return;
                const path = data.entity_type === "team" ? `/teams/${data.entity_id}` : `/trainer-listings/${data.entity_id}`;
                navigate(path, { replace: true });
            })
            .catch(() => { if (active) setError(true); });
        return () => { active = false; };
    }, [sport, slug, navigate]);

    if (error) {
        return (
            <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6" data-testid="slug-not-found">
                <h1 className="text-3xl font-extrabold text-white mb-2">URL not found</h1>
                <p className="text-[#a0a0a0] mb-6"><span className="text-[#ff5a1f]">travelsports.info/{sport}/{slug}</span> isn’t assigned to any listing.</p>
                <Link to="/" className="text-[#22c55e] hover:underline">← Back to home</Link>
            </div>
        );
    }
    return <div className="min-h-[60vh] flex items-center justify-center text-[#a0a0a0]" data-testid="slug-loading">Redirecting…</div>;
}
